<template>
  <Teleport to="body">
    <div
      v-if="aberto"
      class="pesquisa-geral-modal-overlay"
      @click.self="$emit('fechar')"
    >
      <div class="pesquisa-geral-modal-container">
        <form class="pesquisa-geral-modal-input-wrapper" @submit.prevent>
          <i class="fa-solid fa-magnifying-glass pesquisa-geral-icone-lupa font-size-16 text-cinza-texto"></i>
          <input
            ref="inputRef"
            type="text"
            class="pesquisa-geral-modal-input"
            :placeholder="placeholderPesquisando"
            :value="termoBusca"
            autocomplete="off"
            @input="aoDigitar"
            @keydown="aoApertarTecla"
          />
          <i v-if="termoBusca" class="fa-solid fa-xmark pesquisa-geral-botao-limpar" @mousedown.prevent="aoLimpar"></i>
        </form>
        <ul
          v-if="dropdownAberto && resultadosFiltrados.length > 0"
          class="pesquisa-geral-dropdown"
          :class="{ 'pesquisa-geral-dropdown--navegando-teclado': indiceAtivo >= 0 }"
          @mousemove="aoMoverMouse"
        >
          <li
            v-for="(item, indice) in resultadosFiltrados"
            :key="indice"
            class="pesquisa-geral-item-resultado"
            :class="{ 'pesquisa-geral-item-resultado--ativo': indice === indiceAtivo }"
            :ref="(el) => setItemRef(el, indice)"
          >
            <tool-tip
              v-if="mensagemTooltip(item)"
              :texto="mensagemTooltip(item)"
              placement="bottom"
              tag="div"
              data-custom-class="custom-maino-tooltip"
            >
              <template #content>
                <a
                  :href="`/${item.action}`"
                  :class="{ 'pesquisa-geral-link-desabilitado': !item.has_submenu }"
                  @click="aoClicarResultado($event, item)"
                >
                  {{ item.description }}
                </a>
              </template>
            </tool-tip>
            <a
              v-else
              :href="'/' + item.action"
              :class="{ 'pesquisa-geral-link-desabilitado': !item.has_submenu }"
              @click="aoClicarResultado($event, item)"
            >
              {{ item.description }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import ToolTip from '../../helpers/ToolTip.vue'
import usePesquisaGeral from './usePesquisaGeral'

export default {
  name: 'ModalPesquisa',
  components: { ToolTip },
  props: {
    aberto: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['fechar'],
  setup(props, { emit }) {
    const composable = usePesquisaGeral({ tratarEscape: false })

    function aoApertarEscape(evento) {
      if (evento.key === 'Escape') emit('fechar')
    }

    watch(
      () => props.aberto,
      (novoValor) => {
        if (novoValor) {
          nextTick(() => {
            if (composable.inputRef.value) composable.inputRef.value.focus()
          })
          document.addEventListener('keydown', aoApertarEscape)
        } else {
          composable.termoBusca.value = ''
          composable.dropdownAberto.value = false
          composable.indiceAtivo.value = -1
          composable.itensRefs.value = []
          document.removeEventListener('keydown', aoApertarEscape)
        }
      }
    )

    onMounted(() => {
      composable.carregarSubmenus()
    })

    onBeforeUnmount(() => {
      document.removeEventListener('keydown', aoApertarEscape)
    })

    return {
      ...composable,
    }
  },
}
</script>
